import React, { useEffect, useState } from 'react';
import { fetchCrops, fetchDiseases } from '../api/cropService';
import axiosInstance from '../api/axiosInstance';
import { useTranslation } from 'react-i18next';
import { getaccesstoken } from '../context/AuthContext';

const apiPrefix = process.env.REACT_APP_API_PREFIX;

const DeleteProblem = () => {
  const { t } = useTranslation();
  const [crops, setCrops] = useState([]);
  const [selectedCrop, setSelectedCrop] = useState(null);
  const [diseases, setDiseases] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadCrops = async () => {
      try {
        const data = await fetchCrops(true);
        setCrops(data);
        if (data.length > 0) setSelectedCrop(data[0]);
      } catch (error) {
        console.error('Failed to fetch crops:', error);
      }
    };
    loadCrops();
  }, []);

  useEffect(() => {
    const loadDiseases = async () => {
      if (!selectedCrop) return;
      setLoading(true);
      try {
        const data = await fetchDiseases(selectedCrop.cid, true);
        setDiseases(data);
      } catch (error) {
        console.error('Failed to fetch diseases:', error);
      } finally {
        setLoading(false);
      }
    };
    loadDiseases();
  }, [selectedCrop]);

  const handleDelete = async (disId) => {
    try {
      await axiosInstance.delete(`${apiPrefix}/disease/${disId}`, {
        headers: {
          'auth-token': getaccesstoken(),
        }
      });
      setDiseases(prev => prev.filter(d => d.disId !== disId));
      alert(t('expert.deleteProblem.successMessage'));
    } catch (error) {
      console.error('Delete error:', error);
      alert(t('expert.deleteProblem.failMessage'));
    }
  };

  return (
    <div className="flex h-screen">
      {/* Diseases list */}
      <div className="w-2/3 p-4 overflow-y-auto">
        <h2 className="text-xl font-bold mb-4">{t('expert.deleteProblem.pageTitle')}</h2>
        {loading ? (
          <p className="text-gray-600">{t('expert.deleteProblem.loading')}</p>
        ) : (
          <ul>
            {diseases.length === 0 ? (
              <p className="text-gray-600">{t('expert.deleteProblem.noProblemsFound')}</p>
            ) : (
              diseases.map(disease => (
                <li
                  key={disease.disId}
                  className="flex justify-between items-center border-b py-2"
                >
                  <span className="font-medium text-gray-800">{disease.chemical_name || disease.scientific_name}</span>
                  <button
                    onClick={() => handleDelete(disease.disId)}
                    className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-sm"
                  >
                    {t('expert.deleteProblem.deleteButton')}
                  </button>
                </li>
              ))
            )}
          </ul>
        )}
      </div>

      {/* Crops list */}
      <div className="w-1/3 p-4 border-r border-gray-200 overflow-y-auto">
        <h2 className="text-xl font-bold mb-4">{t('expert.deleteProblem.existingCropsTitle')}</h2>
        <ul>
          {crops.map(crop => (
            <li
              key={crop.cid}
              onClick={() => setSelectedCrop(crop)}
              className={`cursor-pointer p-2 rounded mb-2 ${selectedCrop?.cid === crop.cid
                ? 'bg-blue-500 text-white'
                : 'hover:bg-gray-100'
                }`}
            >
              {crop.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DeleteProblem;